<template>
  <div>
    <label class="form-label block mb-1">{{ label }}</label>
    <p class="text-xs text-gray-400 mb-2">Si no marcas ninguno, aplica a todos los tipos de equipo y ubicación.</p>
    <div class="grid grid-cols-2 gap-4 border rounded p-3 max-h-48 overflow-y-auto">
      <div>
        <div class="text-xs font-bold text-gray-500 mb-1">Tipos de equipo</div>
        <label v-for="t in equipmentTypes" :key="'e' + t.id" class="flex items-center gap-2 text-sm mb-1 cursor-pointer">
          <input type="checkbox" :value="t.id" :checked="modelValue.includes(t.id)" @change="toggle(t.id)" />
          {{ t.name }}
        </label>
      </div>
      <div>
        <div class="text-xs font-bold text-gray-500 mb-1">Tipos de ubicación</div>
        <label v-for="t in locationTypes" :key="'l' + t.id" class="flex items-center gap-2 text-sm mb-1 cursor-pointer">
          <input type="checkbox" :value="t.id" :checked="modelValue.includes(t.id)" @change="toggle(t.id)" />
          {{ t.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    equipmentTypes: { type: Array, default: () => [] },
    locationTypes: { type: Array, default: () => [] },
    label: { type: String, default: 'Tipos a los que aplica' },
  },
  emits: ['update:modelValue'],
  methods: {
    toggle(id) {
      const current = [...this.modelValue]
      const idx = current.indexOf(id)
      if (idx === -1) {
        current.push(id)
      } else {
        current.splice(idx, 1)
      }
      this.$emit('update:modelValue', current)
    },
  },
}
</script>
